import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { deleteCircuit } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeleteCircuit = (
  options: UseMutationOptions<void, unknown, number, unknown>
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      await extractData(deleteCircuit({ path: { id } }));
    },
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['circuits'],
      });
      options.onSuccess?.(...args);
    },
  });
};
